import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

import * as enums from '../../enums'

export const CONFIGURATION_INPUT = graphql.transformers.IN.object<
  ents.extra.space.Report.Configuration.UnclaimedRooms,
  graphql.schema.SpaceReportUnclaimedRoomsConfigurationInput
>({
  format: graphql.transformers.IN.nonNull(enums.format.TRANSFORMER),
})
